<script setup lang="ts">
const props = defineProps<{
  rayId?: string
  method: string
  url: string
}>()

const publicConfig = useRuntimeConfig().public
const accountId = publicConfig.CLOUDFLARE_ACCOUNT_ID

const securityEventsHref = computed(() => {
  return `https://dash.cloudflare.com/${accountId}/security-center/events?ray-id=${props.rayId}`
})

const messageForCloud = computed(() => {
  const rayIdMessage = props.rayId
    ? `- Ray ID: ${props.rayId}
  - Link to security events: ${securityEventsHref.value}`
    : ''
  return `
  Hi @Cloud Engineer on Interrupt,

  Our Cloudflare security rules blocked this request

  - App URL: ${window.location.origin}${window.location.pathname}
  - Endpoint: ${props.method} ${props.url}
  - Environment: ${publicConfig.ENVIRONMENT_NAME}
  ${rayIdMessage}
  `
})

const { copy, copied } = useClipboard()
const toast = useToast()
whenever(copied, () => {
  toast.add({
    title: 'Copied',
    description: 'Message copied to clipboard',
    color: 'success',
  })
})

const onCopy = async () => {
  await copy(messageForCloud.value)
}
</script>

<template>
  <UModal :dismissible="false">
    <template #header="{ close }">
      <div class="text-error-600 flex w-full items-center gap-2">
        <UIcon name="i-ph-shield-warning" class="size-8" />
        <div class="flex-1">
          <h3 class="font-semibold">Blocked for Security Reasons</h3>
        </div>
        <UButton
          label="Close"
          trailing-icon="i-ph-x-bold"
          variant="ghost"
          @click="close()"
        />
      </div>
    </template>

    <template #body>
      <div class="space-y-4">
        <p>
          Our security rules blocked this request, please copy the message below
          so we can help you resolve the issue.
        </p>

        <div class="bg-muted rounded-md p-4 pt-2">
          <header class="flex justify-end">
            <UButton
              :icon="copied ? 'i-ph-check' : 'i-ph-copy'"
              :label="copied ? 'Copied' : 'Copy'"
              color="neutral"
              size="xs"
              variant="ghost"
              @click="onCopy"
            />
          </header>
          <MDC
            class="prose mb-2 text-sm font-medium"
            :value="messageForCloud"
          />
        </div>

        <UButton
          class="bg-[#007a5a] text-white hover:bg-[#007a5a]/90 hover:shadow"
          block
          href="https://rialtic.slack.com/archives/CPL337H3P"
          icon="i-ph-slack-logo"
          label="Message Cloud"
          target="_blank"
          trailing-icon="i-ph-arrow-square-out"
          @click="onCopy"
        />
      </div>
    </template>
  </UModal>
</template>
